import * as React from "react"

import {
  DEFAULT_VISIBLE_COLUMNS,
  OPTIONAL_COLUMNS,
  type ColumnKey,
} from "@/components/alfred/alfred-devices-table"

export const ALFRED_DEVICE_VISIBLE_COLUMNS_STORAGE_KEY =
  "alfred-device-visible-columns"

const allowedColumns = new Set<ColumnKey>(OPTIONAL_COLUMNS.map((column) => column.key))

function readVisibleColumns(): Set<ColumnKey> {
  try {
    const stored = window.localStorage.getItem(ALFRED_DEVICE_VISIBLE_COLUMNS_STORAGE_KEY)
    if (!stored) return new Set(DEFAULT_VISIBLE_COLUMNS)

    const parsed: unknown = JSON.parse(stored)
    if (!Array.isArray(parsed)) return new Set(DEFAULT_VISIBLE_COLUMNS)

    return new Set(
      parsed.filter(
        (column): column is ColumnKey =>
          typeof column === "string" && allowedColumns.has(column as ColumnKey),
      ),
    )
  } catch {
    return new Set(DEFAULT_VISIBLE_COLUMNS)
  }
}

export function useAlfredDeviceVisibleColumns() {
  const [visibleColumns, setVisibleColumnsState] = React.useState(readVisibleColumns)

  const setVisibleColumns = React.useCallback((columns: Set<ColumnKey>) => {
    setVisibleColumnsState(columns)
    try {
      window.localStorage.setItem(
        ALFRED_DEVICE_VISIBLE_COLUMNS_STORAGE_KEY,
        JSON.stringify([...columns]),
      )
    } catch {
      // Keep the in-memory selection when storage is unavailable.
    }
  }, [])

  return [visibleColumns, setVisibleColumns] as const
}
